import { z } from "@hono/zod-openapi";

// The reference mixins, and nothing per-subject: one name per way an event can point at a core identity. A subject's
// own composition of these lives beside the rest of that subject's vocabulary, in `subjects/<subject>/refs.ts`, so
// this file does not grow with the catalog — a new kind adds a file under its category, a new subject adds a
// directory under `subjects/`, and neither touches this one.
//
// Required-versus-nullable is spelled as two names rather than one name and a flag, so a subject's composition reads
// as a sentence and the difference is impossible to skim past. These are the DTO half of a vocabulary the table types
// in `storage/tmsEventTables.ts` state again in Drizzle's type system; the registry checks the two agree for every
// registered subject.

/** The event happened on this unit, and the vendor always names it. */
export const onVehicleRefs = { vendorVehicleKey: z.string() };

/** The event happened on a unit when the vendor names one. */
export const maybeOnVehicleRefs = { vendorVehicleKey: z.string().nullable() };

/** The event is about this driver. */
export const onDriverRefs = { workspaceMembershipId: z.string() };

// `maybeOnDriverRefs` is the obvious parallel; add it with the first subject that needs it, not before.
